import hydraulicDataConfig from '@/api/config/hydraulicDataConfig'
import { queryKeys } from '@/constant/common'
import { APIResponseList, SearchParams } from '@/types/common'
import { HydraulicType } from '@/types/hydraulic'
import { QueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query'

function useSearchHydraulic(
  searchParams: SearchParams = {},
  interfaceId: number,
  queryOptions?: QueryOptions,
): UseQueryResult<APIResponseList<HydraulicType>, any> {
  return useQuery(
    [queryKeys.hydraulic, interfaceId, searchParams],
    async () => {
      const { data } = await hydraulicDataConfig.getAll({
        ...searchParams,
        interfaceId,
      })

      if (!data) return null

      return {
        list: data?.data,
        page: data.page,
        size: data.size,
        sort: data.sort,
        totalCount: data.totalCount,
        totalPage: data.totalPage,
      }
    },
    queryOptions,
  )
}

export default useSearchHydraulic
